import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { List } from "./List";
export var View = function () {
    return (_jsx(React.Fragment, { children: _jsx(List, {}) }));
};
